<div class="main-content py-2 px-0 px-lg-2">
  <div class="section-menu-items">
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['all-products']"
      routerLinkActive="router-link-active"
    >
      <span translate class="translate"> pages.newRetailer.manageProducts</span>
      <mat-icon class="ms-2">widgets</mat-icon>
    </button>
    <button
    [disabled]="isButtonDisabled"
      mat-flat-button
      class="item-each"
      [routerLink]="['add-product']"
      routerLinkActive="router-link-active"
    >
      <span translate class="translate">  pages.newRetailer.addProducts</span>
      <mat-icon class="ms-2">add_box</mat-icon>
    </button>
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['products-history']"
      routerLinkActive="router-link-active"
    >
      <span translate class="translate"> pages.newRetailer.history</span>
      <mat-icon class="ms-2">history</mat-icon>
    </button>
    <button mat-flat-button class="item-each" [routerLink]="['pinless-products']" routerLinkActive="router-link-active">
      <span translate class="translate">Pinless Rates</span>
      <mat-icon class="ms-2">timelapse</mat-icon>
    </button>
  </div>
  <router-outlet></router-outlet>
</div>
